import { render, staticRenderFns } from "./standard-process-new-detail.vue?vue&type=template&id=75aff698&scoped=true"
import script from "./standard-process-new-detail.vue?vue&type=script&lang=js"
export * from "./standard-process-new-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aff698",
  null
  
)

export default component.exports